import React, { memo, useState, useCallback } from "react";
import { useTranslate } from "helpers";
import { NjuskaloSettingsCardProps } from "./types";
import { NjuskaloSettings } from "../../../../types";
import { TextField } from "ui/components/TextField/TextField";
import { Button } from "ui/components/Button/Button";
import { Modal } from "ui/components/Modal";
import ModalHeader from "ui/components/Modal/ModalHeader";
import ModalBody from "ui/components/Modal/ModalBody";
import NjuskaloEditCard from "./components/NjuskaloEditCard/NjuskaloEditCard";

const NjuskaloSettingsCard: React.FC<NjuskaloSettingsCardProps> = ({
  settings,
  onSave,
  isLoading = false,
}) => {
  const { t } = useTranslate();
  const [formValues, setFormValues] = useState<NjuskaloSettings>(settings);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);

  const handleEditClick = () => {
    setShowEditModal(true);
  };

  const handleEditSuccess = useCallback(() => {
    onSave(formValues);
    setShowEditModal(false);
  }, [formValues, onSave]);

  return (
    <>
      <div className="flex flex-col xl:flex-row gap-6 xl:gap-32">
        <div className="flex flex-col flex-1 max-w-[300px] ">
          <div>
            <p className="text-base font-bold text-slate-600 py-3">
              {t("admin.integration.njuskalo.settings.title")}
            </p>
            <p className="text-sm">
              {t("admin.integration.njuskalo.settings.description")}
            </p>
          </div>
        </div>
        <div className="flex justify-between items-center flex-1  px-3 my-3">
          <div className="flex flex-col">
            <div className="mb-3">
              <TextField
                type="text"
                name="username"
                label={t("admin.integration.njuskalo.username")}
                placeholder={t("admin.integration.njuskalo.username.placeholder")}
                value={formValues.username}
                disabled
                cssClassName="bg-white"
              />
            </div>
            <div>
              <TextField
                name="password"
                label={t("admin.integration.njuskalo.password")}
                value={formValues.password}
                type="password"
                placeholder={t("admin.integration.njuskalo.password.placeholder")}
                disabled
                cssClassName="bg-white"
              />
            </div>
          </div>
          <div>
            <Button
              variant="outlined"
              children={t("admin.edit")}
              onClick={handleEditClick}
              startIcon="/media/icons/plus.svg"
            />
          </div>
        </div>
      </div>

      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <ModalHeader
          title={t("admin.integration.njuskalo.edit.title")}
          icon="/media/images/add-icon.svg"
          onHide={() => setShowEditModal(false)}
        />
        <ModalBody>
          {showEditModal && (
            <NjuskaloEditCard
              settings={formValues}
              setSettings={setFormValues}
              onSuccess={handleEditSuccess}
              onClose={() => setShowEditModal(false)}
            />
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default memo(NjuskaloSettingsCard);
